













import { Prop, Component, Vue } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";
import TaskSearchBarOptions from "../../usecace/template-search-options";

@Component({})
export default class TaskSearchBar extends Vue {
  @Prop({ required: true }) options!: TaskSearchBarOptions;
  @Prop({ default: () => [] }) taskOptions!: SelectOption[];

  submit() {
    this.$emit("submit", this.options);
  }
}
